<template>
    <div class="tbb">
   <div class="sks"><span @click="onClickLeft">
        ＜返回 </span>
    
    </div>
       
          <div
        class="search"
      >
        <van-search
          placeholder="请输入"
          shape="round"
          v-model="value"
          background="#191919"
          @click="go"
          left-icon='none'
           show-action
        >
         <template #action>
    <div @click="go" class="se" ><van-icon name="search" /></div>
  </template>
        </van-search>
      </div>
        <div class="nav-wrap">
      <div
        v-show="!oopupFlag"
        class="nav"
        
      >
        <ul  id="navul">
          <!-- <li
            :class="{ active: statusNav == index }"
            v-for="(item, index) in nav"
            :key="index"
            :id="index"
            @click="addClass(index)"
          >
           
            <span> {{ item.name }}</span>
          </li> -->
           <li
           v-for="(v,i) in oneclass"
           :key="v.id"
            :class="{ active: i == 0 }"   
            :id="0"
            @click="addClass(0)"
          >
            <span> {{v.name}}</span>
          </li>
         
         
        </ul>
      </div>
      <!-- <div
        v-show="oopupFlag"
        class="nav-wrap-all"
      >全部分类</div> -->
<!-- 
      <div
        @click="openAllClass"
        class="xiala"
      >
        <van-icon
          v-show="!oopupFlag"
          name="arrow-down"
        />
        <span>全部</span>
        <van-icon
          v-show="oopupFlag"
          name="arrow-up"
        />
      </div> -->
    </div>
     <van-swipe :autoplay="3000">
      <van-swipe-item
       
      >
        <img src="../../assets/vip/01.jpg" />
       
      </van-swipe-item>
      <van-swipe-item
       
      >
        <img src="../../assets/vip/02.png" />
       
      </van-swipe-item>
      
    </van-swipe>
    <div class="tgou">
       
      <div class="good">
        <ul class="clearfix">
            <li class="fl" v-for="(v,i) in oneclass" :key="v.id"  @click="gop(v.id,i,v.name,v.pid)">
                <img :src="v.image" alt="">
            </li>
        </ul>
      </div>
      <div class="good1">
        <ul class="clearfix">
        <li @click="gp(4506)" class="fl">
            <img src="../../assets/vip/11.png" alt="">
        </li><li @click="gp(4097)" class="fl">
            <img src="../../assets/vip/12.png" alt="">
        </li>
    </ul>
      </div>
      <div class="gou">
                  <img src="../../assets/vip/13.png" alt="">

      </div>
    <div class="sp">
        <ul class="clearfix">
            <li @click="gp(v.id)" v-for="v in twoclass" :key="v.id" >
                <img :src="v.thumb" alt="">
                 <div class="name">
                    {{v.name}}
                </div>
                <div class="price">
                   ￥ {{v.min_price}}
                </div>
               
            </li>
        </ul>
    </div>
    </div>
    <div class="gou">
                  <img src="../../assets/vip/14.png" alt="">

      </div>
     <img src="../../assets/vip/15.png" />
     <img src="../../assets/vip/16.png" />
     <img src="../../assets/vip/17.png" />
    </div>
</template>
<script>
import Vue from 'vue'
import { Search,Swipe, SwipeItem,Picker,Popup, Tab, Tabs, Icon, Tabbar, TabbarItem, Lazyload, Toast,NavBar } from 'vant'
Vue.use(Search)
  .use(Tab)
  .use(Tabs)
  .use(Icon)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Lazyload).use(Swipe)
  .use(SwipeItem).use(Picker).use(Popup).use(NavBar)
 
export default {
   created(){
   this.axios.get('listGoods', { params: { store_id: this.$store.state.shopid ,class_id:1973 ,class_name:'卫浴'} }).then(res => {
//   console.log(res)
this.oneclass=res.data.data.threeClass
this.twoclass=res.data.data.recommend

        }).catch(ref => { })
  },
    data() {
        return{
       oopupFlag:false ,
       statusNav:0,
       ctxt:'所属地',
     showPicker:false,
        columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
      alls:false,
      oneclass:[],
      twoclass:[],
      qdf:true,
      value:''
        }
    },
    methods:{
        onSearch(){
          // console.log(this.value)
          this.$router.push('/gongx')
        },
         onSearch1(){
          // console.log(this.value)
          this.$router.push('/gongd')
        },
        openAllClass () {
      
      //  this.alls=true
      },
      onClickLeft () {
      this.$router.go(-1)
    },
     addClass(){

        },
      goi(){
          this.$router.push('/')
        },
        go(){
          this.$router.push('search')

        },
      goc(){
        this.showPicker=true
      },
      gp(id){
        this.$router.push({ name: 'product', query: { id } })
      },
      gop(v,i,m,pid){
          this.$store.state.pid = pid
       this.$store.state.spid=v
       this.$store.state.spid1=i
       this.$store.state.soncname=m
    //    this.$store.state.moid=this.hlist.yi
       
      this.$router.push({
          name: 'brandproduct',
          query: {
            id: v,
            name:m
          },
        })
      return false
      },
      onConfirm(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.ctxt=value
      this.showPicker=false
    },
    onChange(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancel() {
      Toast('取消');
    },
    close(){
      this.alls=false
    },
    }
}
</script>
<style lang="less" scoped>
  .tbb{
  background-color:  #efeff0;

  }
.sks {
  width: 100%;
  z-index: 99;
  height: 1.2rem;
  background-color: #191919;
//   text-align: center;
  // padding-left: 1rem;
//   font-weight: 600;
  font-size: 0.35rem;
  line-height: 1.2rem;
  position: fixed;
  top: 0;
  left: 0;
  color: #fff;
  //   margin-top: 0.5rem;
  // position: fixed;
  // top: 0;
  // z-index: 99;
  // width: 100%;
  span {
    width: 2rem;
    position: absolute;
    left: 0.2rem;
    font-size: 0.35rem;
  }
}


.nav-wrap {
//   position: fixed;
//   top: 1.27rem;
position: relative;
  padding-left: 0.266667rem;
//   left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 999;
  height: 1.3rem;
   background-color:#191919;

  // background-color: #f99;

  .nav-wrap-all {
    width: 100%;
    height: 0.653333rem;
    padding-left: 0.2rem;
    // color: #fff;
    font-size: 0.45rem;
  }

  .xiala {
    width: 17%;
    height: 0.65rem;
    display: flex;
    justify-content: center;
      background-color:#191919;

    // background-color: #f99;

    color: #a3a3a1;
    font-size: 0.55rem;
    align-items: center;
    span{
      font-size: 0.4rem;
    }
    // transition: 0.3s;
  }

  .nav {
    width: 93%;
    overflow-x: auto;
      background-color:#191919;

    // background-color: #f99;

    ul {
      display: flex;
      white-space: nowrap;
justify-content :start;

      li {
        position: relative;
        padding: 0.1rem 0.3rem;
        span {
          color: #fff;
          font-size: 0.4rem;
          font-weight: 700;
        }
      }
      .li1{
        padding-left: 0.2rem;
      }
      li.active {
        // background-color: #c4af78;
        // border-radius: 0.2rem;
        span{
        color: #ff5500;

        }
      }
      .aimg{
  padding-left:0.3rem ;
  // padding-top: 0.1rem;
  // flex-grow:1;
  position: relative;
  bottom: 0.11rem;
  // margin: 0.1rem;
  img{
  width: 1.5rem;

// height: 110%;
  }
}
      .hot {
        width: 0.8rem;
        height: 0.7rem;
        position: absolute;
        top: -0.1rem;
        right: -0.35rem;
        color: #ffff00;
        font-size: 0.4rem;
      }

      
      
    }
    .s1{
justify-content : flex-start;

    }
  }
}
.nav-oopup {
  position: fixed;
  width: 100%;
  top: 2.5rem;
  height: 0;
  overflow: hidden;
  transition: height 0.3s;
  z-index: 20;
//   color: #fff;
  background-color:#191919;
  // background-color: #f99;

  ul {
    display: flex;
    padding-top: 0.3rem;
    flex-wrap: wrap;

    li {
      width: 30%;
      height: 0.5rem;
      line-height: 0.5rem;
      text-align: center;
      margin-left: 0.27rem;
      border-radius: 0.1rem;
      margin-bottom: 0.3rem;
      box-sizing: border-box;
      span{
      font-size: 0.4rem;

      }
    }

    .active {
      width: 30%;
      background-color: #c4af78;
      border-radius: 0.4rem;
      padding: -1px 0.2rem;
    }
  }
}
.search{
  margin-top: 1.1rem;
  position: relative;
  background-color: #191919;

  .se{
    position: absolute;
    top: 0.25rem;
    right: 0.35rem;
    background-color: #ff5500;
    border-radius: 0.5rem;
    padding: 0rem 0.4rem;
    // padding-top: 0.2rem;
    // line-height: 1.5rem;
    height: 0.95rem;
    width: 1.5rem;
    padding-top: 0.1rem;
    padding-left: 0.5rem;
    font-size: 0.5rem;
    color: #fff;
  }
}

 .tgou{
  width: 100%;
  background-color:  #efeff0;
//   height: 21.3rem;
  // padding: 0.2rem;
  // padding: 0.1rem;
  .g1{
    padding: 0.1rem;
  }
  li{
    // margin: 0.12rem;
    width: 33%;
    padding: 0.1rem;
    text-align: center;
    img{
      width: 100%;
      margin: 0 auto;
    }
    p{
      font-size: 0.4rem;
      padding-top: 0.2rem;
      color: #6d6d6d;
    }
  }
  .good{
   padding: 0.2rem;
  background-color:  #efeff0;
    
    ul{
      li{
        
        width: 25%;
        margin: 0;
        padding: 0.05rem;
        // padding: 0.2rem 0;
        // padding-top: 0.2rem;
        margin-top: 0.2rem;
        img{
          // width: 97%;
          width: 100%;
        //   height: 2.1rem;
        }
      }
    }
  }

 .good1{
   padding: 0.2rem;
  background-color:  #efeff0;
    
    ul{
      li{
        
        width: 50%;
        margin: 0;
        padding: 0.05rem;
        // padding: 0.2rem 0;
        // padding-top: 0.2rem;
        margin-top: 0.2rem;
        img{
          // width: 97%;
          width: 100%;
        //   height: 2.1rem;
        }
      }
    }
  }
}
.gou{
    padding-left: 0.2rem;
    width: 70%;
}
.sp{
    padding: 0.2rem;
    li{
        float: left;
        width: 50%;
        text-align: left;
        .name{
            color: #1a1a1a;
            font-size: 0.4rem;
            // line-height: 0.9rem;
            padding-top: 0.2rem;
        }
        .price{
            color: #f61616;
            font-size: 0.45rem;
        }
    }
}
</style>